import { connect } from 'react-redux';
import withMobile from '../hocs/withMobile';
import PaymentBlock from '../components/PaymentBlock';

// Actions:
import { confirmClientAction } from '../../../store/client/actions';
import { submitCertificateAction } from '../store/certificate/sagaActions';

// Selectors:
import {
  getCardIsValid,
  getPaymentAmount,
} from '../../../store/payment/selectors';
import { getIsProcessing } from '../store/view/selectors';
import { getIsCertificateCreated } from '../store/certificate/selectors';

const mapStateToProps = (state) => ({
  paymentAmount: getPaymentAmount(state),
  isCardValid: getCardIsValid(state),
  isCreated: getIsCertificateCreated(state),
  isLoading: getIsProcessing(state),
});

const mapDispatchToProps = (dispatch) => ({
  onGoBack: () => dispatch(confirmClientAction(null)),
  onSubmit: () => dispatch(submitCertificateAction()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withMobile(PaymentBlock));
